"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferedShiftTakenMessage = void 0;
const utils_1 = require("../utils");
const base_html_1 = require("./base-html");
class OfferedShiftTakenMessage {
    constructor(entry, offeredBy, takenBy) {
        this.entry = entry;
        this.offeredBy = offeredBy;
        this.takenBy = takenBy;
        this.title = "Dein Angebot zum Schichttausch wurde angenommen!";
    }
    get recipient() {
        return this.offeredBy.email || "";
    }
    get text() {
        const entry = this.entry;
        return `
Hallo ${this.offeredBy.firstName},

Gute Nachrichten! ${this.takenBy.firstName} ${this.takenBy.lastName} hat folgende Schicht, die du zum Tausch freigegeben hattest, übernommen:

${(0, utils_1.formatWeekDay)(entry.date)}, ${(0, utils_1.formatDate)(entry.date)} ${(0, utils_1.toTimeString)(entry.startPlanned) || "offen"} - ${(0, utils_1.toTimeString)(entry.endPlanned) || "offen"} (${entry.position.name})

Mit freundlichen Grüßen,
Dein Pentacode Team
`;
    }
    get html() {
        const entry = this.entry;
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.offeredBy.firstName},`)}

            ${(0, base_html_1.paragraph)(`
Gute Nachrichten! ${this.takenBy.firstName} ${this.takenBy.lastName} hat folgende Schicht, die du zum Tausch freigegeben hattest, übernommen:`)}

            ${(0, base_html_1.paragraph)(`${(0, utils_1.formatWeekDay)(entry.date)}, ${(0, base_html_1.bold)(`${(0, utils_1.formatDate)(entry.date)} ${(0, utils_1.toTimeString)(entry.startPlanned) || "offen"} - ${(0, utils_1.toTimeString)(entry.endPlanned) || "offen"}`)} (${entry.position.name})`, `padding: 10px; border: solid 1px; border-radius: 5px; color: ${base_html_1.colorHighlight};`)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.OfferedShiftTakenMessage = OfferedShiftTakenMessage;
//# sourceMappingURL=offered-shift-taken.js.map